import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { customGetAPIWithToken } from "services/utils/CustomAPI";
import { styled, alpha } from "@mui/material/styles";
import { pathAndProducts, pathAndProductsScreen } from "services/constants";
import moment from "moment";
import { GlobalDialogBox } from "components/GlobalDialogBox";
import { tooltipStyleProps } from "services/constants/Styles";
import {
  setAttendanceCompanyId,
  setAttendanceCompanyName,
  setAttendanceShiftName,
  setAttendanceShiftId,
  setAttendanceDate,
} from "services/Redux/TeamZone";
import MuiDrawer from "@mui/material/Drawer";
import comLogo from "../../assets/img/brand/company_logo.png";
import * as Mui from "@mui/material";
import {
  Collapse,
  Box,
  List,
  CssBaseline,
  IconButton,
  ListItem,
  Card,
  CardContent,
  DialogContent,
  ListItemIcon,
  ListItemButton,
  Alert,
  InputBase,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { getCardBackgroundColor } from "services/utils/Status";
import SearchIcon from "@mui/icons-material/Search";
import Rectangle_10126 from "../../assets/img/brand/1_2.png";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { themes } from "services/constants";
import { Grid, Typography, ListItemText } from "@mui/material";
import { customGetAPI } from "services/utils/CustomAPI";
import {
  setCurrentScreen,
  setSubMenuExpand,
} from "services/Redux/userManagament";
import {
  setEditProject,
  setProjectStatus,
  setReloadHRMSApi,
} from "services/Redux/leaveManagement";
import {
  setShowShiftBack,
  setAdminShiftLocation,
} from "services/Redux/TeamZone";
import { setFilterApi } from "services/Redux/userManagament";
import { setCurrentLocation } from "services/Redux/userToken";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
  setTopbarCompanyId,
  setTopbarCompanyName,
  setScreenAccess,
  setVisible,
} from "services/Redux/userToken";
import { showToast } from "services/utils/Status";
import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";
import sessionHandling from "services/utils/notificationUtils";
import { CustomAutoComplete } from "components/CustomComponents";
import { UserSidePeek } from "./UserSidePeek";
import { rowEndStyle } from "services/constants/Styles";
const drawerWidth = 240;

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: 20,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    borderRadius: 20,
    backgroundColor: alpha(theme.palette.common.white),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "40ch",
    },
  },
}));

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});
const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export const Sidebar = ({ routes, toggleSidenav, setOpen, open }) => {
  const { currentScreen, sidebarExpand, subMenuExpand } = useSelector(
    (state) => state.userReducer,
  );
  const { topbarCompanyId, topbarCompanyName, userScreenAccess, companyList } =
    useSelector((state) => state.tokenReducer);

  let primaryCompany = JSON.parse(localStorage.getItem("companyDetails"))
    ? JSON.parse(localStorage.getItem("companyDetails")).filter((data) => {
        return data?.isprimary;
      })
    : [];
  const { token, domain, globalSearchValue, currentLocation, userDetails } =
    useSelector((state) => state.tokenReducer);
  const location = useLocation();
  let firstLetter = userDetails?.first_name?.charAt(0).toUpperCase();
  const [openSidePeek, setOpenSidePeek] = useState(false);
  const [deviceDetails, setDeviceDetails] = useState(null);
  const [openDialog1, setOpenDialog1] = useState(false);
  const [updateProfileSidePeek, setUpdateProfileSidePeek] = useState(false);
  const history = useHistory();
  const [expandOpen, setExpandOpen] = useState(sidebarExpand);
  const dispatch = useDispatch();
  const [currentRoute, setCurrentRoute] = React.useState(routes[0]);

  const [expandSubMenuOpen, setExpandSubMenuOpen] = useState("");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1400) {
        setOpen(false);
      } else {
        setOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [setOpen, toggleSidenav]);

  const handleDrawerOpen = () => {
    toggleSidenav();
  };

  const attendanceScreenConfigurations = useCallback(() => {
    dispatch(setAttendanceCompanyId(99999));
    dispatch(setAttendanceCompanyName("All Companies"));
    localStorage.setItem("attendanceCompanyId", 99999);
    localStorage.setItem("attendanceCompanyName", "All Companies");
    dispatch(setAttendanceShiftId(99999));
    dispatch(setAttendanceShiftName("All"));
    localStorage.setItem("attendanceShiftId", 99999);
    localStorage.setItem("attendanceShiftName", "All");
    dispatch(setAttendanceDate(moment(new Date()).format("YYYY-MM-DD")));
    localStorage.setItem(
      "attendanceDate",
      moment(new Date()).format("YYYY-MM-DD"),
    );
  }, [dispatch]);

  const getAccessDetails = useCallback(
    async (topbarCompany, module) => {
      const res = await customGetAPI(
        `${domain}product/access/provisioning/?user_id=${userDetails?.id}&company_id=${topbarCompany}&module=${module}`,
      );
      if (res.ok) {
        let updatedData = res?.responseDetails;
        localStorage.setItem("screenAccess", JSON.stringify(updatedData));
        dispatch(setScreenAccess(updatedData));
      }
    },
    [dispatch, domain, userDetails?.id],
  );

  const getAvailableProducts = async (topbarCompany) => {
    const response = await customGetAPIWithToken(
      `${domain}login/available/products/?user_id=${userDetails?.id}&company_id=${topbarCompany}`,
      token,
    );
    if (response.ok) {
      localStorage.setItem(
        "productAccess",
        JSON.stringify(response.responseDetails),
      );
    }
  };

  const updatePrimaryCompany = useCallback(() => {
    if (topbarCompanyId !== 99999) return;
    const companyDetailsRaw = localStorage.getItem("companyDetails");
    if (!companyDetailsRaw) return;
    let companyDetails = JSON.parse(companyDetailsRaw);
    const primaryCompany = companyDetails.find((data) => data?.isprimary);
    if (!primaryCompany) return;
    dispatch(setTopbarCompanyName(primaryCompany.companyname));
    dispatch(setTopbarCompanyId(primaryCompany.id));
    localStorage.setItem("topbarCompanyName", primaryCompany.companyname);
    localStorage.setItem("topbarCompanyId", primaryCompany.id);
  }, [dispatch, topbarCompanyId]);

  const handleItemClick = useCallback(
    (item) => {
      dispatch(setGlobalSearchValue(""));
      if (item.name !== currentLocation) {
        dispatch(setCurrentLocation(item.name));
        localStorage.setItem("currentScreen", item.name);
        setExpandSubMenuOpen("");
        if (item?.collapse) {
          setExpandOpen(item?.name === currentLocation ? !expandOpen : true);
        }
        if (item.name === "Project") {
          dispatch(setCurrentScreen("Projects"));
          localStorage.setItem("currentSubMenu", "Projects");
          dispatch(setVisible(false));
        } else if (item.name === "Administration") {
          dispatch(setCurrentScreen("Users"));
          localStorage.setItem("currentSubMenu", "Users");
          dispatch(setVisible(false));
        } else if (item.name === "Team Zone") {
          dispatch(setVisible(false));
          dispatch(setCurrentScreen("Calendar"));
          localStorage.setItem("currentSubMenu", "Calendar");
        } else if (item.name === "Settings") {
          dispatch(setVisible(false));
          dispatch(setCurrentScreen(""));
        } else if (item.name === "Invoice") {
          dispatch(setCurrentScreen(""));
          dispatch(setVisible(false));
        } else if (item.name === "My Zone") {
          dispatch(setVisible(false));
          dispatch(setCurrentScreen("Calendar"));
          localStorage.setItem("currentSubMenu", "Calendar");
        } else if (item.name === "Payroll") {
          updatePrimaryCompany();
          dispatch(setVisible(false));
          dispatch(setCurrentScreen("Settings"));
          localStorage.setItem("currentSubMenu", "Settings");
        } else if (item.name === "HR Zone") {
          dispatch(setCurrentScreen("Employee"));
          localStorage.setItem("currentSubMenu", "Employee");
          dispatch(setVisible(false));
        } else if (item.name === "Support Admin") {
          dispatch(setCurrentScreen("Product Control"));
          localStorage.setItem("currentSubMenu", "Product Control");
          dispatch(setVisible(false));
        } else if (item.name === "Tracking") {
          dispatch(setCurrentScreen("Track"));
          localStorage.setItem("currentSubMenu", "Track");
          dispatch(setVisible(false));
        } else if (item.name === "CRM") {
          dispatch(setVisible(true));
        }
        history.push(`${item.layout}${item.uri || item.path}`);
        dispatch(setCurrentLocation(item.name));
        setCurrentRoute(item);
        getAccessDetails(topbarCompanyId, item.name);
      } else {
        if (item?.collapse) {
          setExpandOpen(item?.name === currentLocation ? !expandOpen : true);
        }
      }
    },
    [
      currentLocation,
      dispatch,
      expandOpen,
      getAccessDetails,
      history,
      topbarCompanyId,
      updatePrimaryCompany,
    ],
  );

  const seticons = useCallback(
    (icon, name) => {
      const Icon = icon;
      return (
        <Mui.Tooltip
          slotProps={tooltipStyleProps}
          arrow
          title={!open ? name : null}
        >
          <Icon
            style={{
              color:
                name === currentLocation ? themes.headLine : themes.headLine,
              fontSize: {
                sx: "16px",
                sm: "16px",
                md: "16px",
                lg: "20px",
                xl: "20px",
              },
            }}
          />
        </Mui.Tooltip>
      );
    },
    [currentLocation, open],
  );

  const seticonsSubmenu = useCallback(
    (icon, name) => {
      const Icon = icon;

      return (
        <Mui.Tooltip
          slotProps={tooltipStyleProps}
          arrow
          title={!open ? name : null}
        >
          <Icon
            size="small"
            style={{
              color: name === currentScreen ? themes.headLine : themes.headLine,
            }}
          />
        </Mui.Tooltip>
      );
    },
    [currentScreen, open],
  );

  const handleNestedNavigation = useCallback(
    (menuItem) => {
      if (menuItem.name === "Tasks") {
        dispatch(setEditProject(null));
        dispatch(
          setProjectStatus([
            "ToDo",
            "InProgress",
            "Review",
            "Testing",
            "Completed",
          ]),
        );
        dispatch(setReloadHRMSApi(true));
      }
      if (menuItem.name === "Shift") {
        dispatch(setShowShiftBack(false));
        dispatch(setFilterApi(true));
        dispatch(setAdminShiftLocation("Shift"));
      }
      if (
        menuItem.name === "Earnings" ||
        menuItem.name === "Payroll Processing" ||
        menuItem.name === "Deductions" ||
        menuItem.name === "Setup"
      ) {
        dispatch(setFilterApi(true));
      }

      if (menuItem.name === "Attendance") {
        attendanceScreenConfigurations();
      }

      history.push(menuItem.path);
      dispatch(setGlobalSearchValue(""));
      dispatch(setCurrentScreen(menuItem.name));
      localStorage.setItem("currentSubMenu", menuItem.name);
      if (window.innerWidth < 1400) {
        setOpen(false);
      }
    },
    [attendanceScreenConfigurations, dispatch, history, setOpen],
  );

  const handleSubMenu = useCallback(
    (subMenu, item, isNestedItem = false) => {
      if (isNestedItem) {
        handleNestedNavigation(subMenu);
        return;
      }

      if (subMenu?.collapse) {
        if (expandSubMenuOpen === subMenu.name) {
          setExpandSubMenuOpen("");
        } else {
          setExpandSubMenuOpen(subMenu.name);

          if (subMenu.collapse && subMenu.collapse.length > 0) {
            const firstNestedItem = subMenu.collapse[0];
            handleNestedNavigation(firstNestedItem);
          }
        }
      } else {
        handleNestedNavigation(subMenu);
        setExpandSubMenuOpen("");
      }
    },
    [expandSubMenuOpen, handleNestedNavigation],
  );

  const handleClose = () => {
    setOpenDialog1(false);
  };

  const getname = useCallback(
    (item) => {
      return (
        <Grid container>
          <Grid xs={11.7}>{item.name}</Grid>
          <Grid xs={0.3}>
            {item?.collapse ? (
              expandOpen && currentLocation === item.name ? (
                <div>
                  <ExpandCircleDownIcon fontSize="10" />
                </div>
              ) : (
                <div></div>
              )
            ) : null}
          </Grid>
        </Grid>
      );
    },
    [currentLocation, expandOpen],
  );

  const returnMenuItems = useCallback(() => {
    const parts = location.pathname.split("/");
    const match = pathAndProducts.find((item) => item.pathname === parts[2]);
    const matchSubmenu = pathAndProductsScreen.find(
      (item) => item.pathname === parts[3],
    );
    const matchNested = pathAndProductsScreen.find(
      (item) => item.pathname === parts[4],
    );

    const isAccessible = match?.productname;
    const isAccessibleSubmenu = matchSubmenu?.productname;
    const isAccessibleNested = matchNested?.productname;

    const submenuAccessible = (submenu) =>
      !!userScreenAccess?.module_details?.some(
        (module) => module.module_name === submenu?.name,
      );

    return (
      <List aria-labelledby="nested-list-subheader">
        {routes.map((item) => {
          if (!item.hideInSidebar) {
            const isMainMenuActive = item?.name === isAccessible;
            const isMainMenuExpanded =
              expandOpen && currentLocation === item.name;

            return (
              <ListItem
                key={item.name}
                disablePadding
                sx={{ display: "block" }}
              >
                <ListItemButton
                  sx={{
                    minHeight: { sx: 35, sm: 35, md: 35, lg: 35, xl: 48 },
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                    backgroundColor: isMainMenuActive
                      ? themes.primaryIndicator
                      : "none",
                    color: isMainMenuActive ? themes.headLine : "none",
                    "&:hover": {
                      backgroundColor: isMainMenuActive
                        ? themes.primaryIndicator
                        : "none",
                    },
                  }}
                  onClick={() => {
                    if (item?.collapse) {
                      setExpandOpen(
                        item?.name === isAccessible ? !expandOpen : true,
                      );
                      setExpandSubMenuOpen("");
                    }
                    handleItemClick(item);
                  }}
                >
                  <Link to={item.uri || item.path} />
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 1.5 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    {seticons(item.icon, item?.name)}
                  </ListItemIcon>
                  <ListItemText
                    primary={getname(item)}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>

                {/* FIRST LEVEL COLLAPSE */}
                {currentLocation === item.name && (
                  <Collapse
                    in={isMainMenuExpanded}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      <div style={{ paddingTop: 2 }}></div>
                      {item?.collapse?.map((submenu) =>
                        submenuAccessible(submenu) ? (
                          <React.Fragment key={submenu.name}>
                            <ListItemButton
                              sx={{
                                pl: open ? 6 : 4,
                                backgroundColor:
                                  submenu.name === isAccessibleSubmenu
                                    ? themes.primaryIndicator
                                    : "none",
                                color:
                                  submenu.name === isAccessibleSubmenu
                                    ? themes.headLine
                                    : "none",
                                "&:hover": {
                                  backgroundColor:
                                    submenu.name === isAccessibleSubmenu
                                      ? themes.primaryIndicator
                                      : "none",
                                },
                              }}
                              onClick={() => {
                                handleSubMenu(submenu, item, false);
                              }}
                            >
                              <ListItemIcon sx={{ minWidth: "35px" }}>
                                {seticonsSubmenu(submenu.icon, submenu.name)}
                              </ListItemIcon>
                              {open ? (
                                <>
                                  <ListItemText
                                    primary={submenu.name}
                                    primaryTypographyProps={{
                                      fontSize: "15px",
                                      lineHeight: 1,
                                    }}
                                  />
                                  {submenu?.collapse && (
                                    <ExpandCircleDownIcon
                                      fontSize="10"
                                      sx={{
                                        transform:
                                          expandSubMenuOpen === submenu.name
                                            ? "rotate(0deg)"
                                            : "rotate(-90deg)",
                                        transition: "transform 0.2s",
                                      }}
                                    />
                                  )}
                                </>
                              ) : null}
                            </ListItemButton>

                            {/* SECOND LEVEL (nested) COLLAPSE */}
                            <div style={{ paddingTop: 2 }}></div>
                            {submenu?.collapse && (
                              <Collapse
                                in={expandSubMenuOpen === submenu.name}
                                timeout="auto"
                                unmountOnExit
                              >
                                <List component="div" disablePadding>
                                  {submenu.collapse.map((nested) => (
                                    <ListItemButton
                                      key={nested.name}
                                      sx={{
                                        pl: open ? 9 : 6,
                                        backgroundColor:
                                          nested.name === isAccessibleNested
                                            ? themes.primaryIndicator
                                            : "none",
                                        color:
                                          nested.name === isAccessibleNested
                                            ? themes.headLine
                                            : "none",
                                        "&:hover": {
                                          backgroundColor:
                                            nested.name === isAccessibleNested
                                              ? themes.primaryIndicator
                                              : "none",
                                        },
                                      }}
                                      onClick={() =>
                                        handleSubMenu(nested, submenu, true)
                                      }
                                    >
                                      <ListItemIcon sx={{ minWidth: "35px" }}>
                                        {seticonsSubmenu(
                                          nested.icon,
                                          nested.name,
                                        )}
                                      </ListItemIcon>
                                      {open ? (
                                        <ListItemText
                                          primary={nested.name}
                                          primaryTypographyProps={{
                                            fontSize: "14px",
                                            lineHeight: 1,
                                          }}
                                        />
                                      ) : null}
                                    </ListItemButton>
                                  ))}
                                </List>
                              </Collapse>
                            )}
                          </React.Fragment>
                        ) : null,
                      )}
                    </List>
                  </Collapse>
                )}
              </ListItem>
            );
          }
          return null;
        })}
      </List>
    );
  }, [
    location.pathname,
    currentLocation,
    expandOpen,
    expandSubMenuOpen,
    open,
    routes,
    seticons,
    seticonsSubmenu,
    userScreenAccess?.module_details,
    getname,
    handleItemClick,
    handleSubMenu,
  ]);

  useEffect(() => {
    if (subMenuExpand) {
      returnMenuItems();
      dispatch(setSubMenuExpand(false));
    }
  }, [dispatch, returnMenuItems, subMenuExpand]);

  const fetchData = async () => {
    try {
      const response = await fetch(`${domain}bio_metric/device_status`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `token ${token}`,
        },
      });
      const res = await response.json();
      if (response.ok) {
        setDeviceDetails(res);
        setOpenDialog1(true);
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error(res.error);
      }
    } catch (error) {
      showToast("error", error.message);
    }
  };

  const handleClick = (event) => {
    setOpenSidePeek(true);
    setUpdateProfileSidePeek(true);
  };

  const changeCompany = (event, data) => {
    if (data) {
      dispatch(setTopbarCompanyName(data?.label));
      dispatch(setTopbarCompanyId(data?.company_id));
      getAccessDetails(data?.company_id, currentLocation);
      getAvailableProducts(data?.company_id);
      localStorage.setItem("topbarCompanyName", data?.label);
      localStorage.setItem("topbarCompanyId", data?.company_id);
    }
  };

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <Drawer variant="permanent" open={open}>
          <Mui.Grid
            container
            sx={{
              paddingLeft: 1.5,
              paddingBottom: !open ? 1.6 : 5.3,
              borderBottom: `1px solid ${themes.sidebarDivider}`,
            }}
          >
            {!open ? (
              <Mui.Grid
                item
                xs={2}
                sx={{
                  paddingTop: 1,
                }}
              >
                <Mui.Tooltip
                  title={userDetails?.firmName}
                  slotProps={tooltipStyleProps}
                >
                  <Mui.Avatar
                    sx={{
                      width: 32,
                      height: 32,
                      bgcolor: "purple",
                    }}
                    alt={userDetails?.firmName.charAt(0).toUpperCase()}
                    src={userDetails?.firmName.charAt(0).toUpperCase()}
                  />
                </Mui.Tooltip>
              </Mui.Grid>
            ) : (
              <Mui.Grid
                item
                xs={!open ? 12 : 9}
                sx={{ paddingTop: 0.5, height: 12 }}
              >
                {primaryCompany.length !== 0 &&
                primaryCompany[0]?.company_logo_url ? (
                  <Mui.Tooltip
                    title={primaryCompany[0].companyname}
                    slotProps={tooltipStyleProps}
                  >
                    <div
                      style={{
                        position: "relative",
                        height: "45px",
                        width: "200px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={primaryCompany[0].company_logo_url}
                        alt={primaryCompany[0].companyname || "Company Logo"}
                        style={{
                          height: "45px",
                          width: "200px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                  </Mui.Tooltip>
                ) : (
                  <Mui.Tooltip
                    title={
                      primaryCompany[0]?.companyname || userDetails?.firmName
                    }
                    slotProps={tooltipStyleProps}
                  >
                    <span
                      style={{
                        display: "block",
                        height: "45px",
                        width: "200px",
                        fontWeight: "bold",
                        fontSize: "20px",
                        color: themes.headLine,
                        textAlign: "center",
                        lineHeight: "45px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {primaryCompany[0]?.companyname ||
                        userDetails?.firmName ||
                        "N/A"}
                    </span>
                  </Mui.Tooltip>
                )}
              </Mui.Grid>
            )}
          </Mui.Grid>
          {returnMenuItems()}
          <Mui.Stack
            direction={open ? "row" : "column"}
            spacing={open ? 0 : -2.5}
            sx={{
              padding: 1,
              position: "absolute",
              bottom: open ? 2 : 1,
              right: 0,
              left: 0,
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {open ? (
              <img
                src={Rectangle_10126}
                alt=""
                style={{ height: "50px", width: "170px" }}
              />
            ) : (
              <img
                src={comLogo}
                alt=""
                style={{ height: "35px", width: "35px" }}
              />
            )}
          </Mui.Stack>
        </Drawer>
        <Mui.AppBar
          sx={{
            backgroundColor: themes.whiteColor,
            boxShadow: "none",
            paddingButtom: 1,
          }}
          position="fixed"
        >
          <Mui.Grid
            container
            sx={{
              paddingLeft: 1,
              paddingTop: 1,
              paddingBottom: 0.1,
              borderBottom: `1px solid ${themes.sidebarDivider}`,
              position: "sticky",
              zIndex: 10,
            }}
          >
            <Mui.Grid
              xs={2}
              sm={1}
              md={4}
              lg={7}
              xl={7}
              sx={{ paddingLeft: open ? 30 : 8 }}
            >
              <Mui.Stack direction="row" sx={{ paddingLeft: 1 }}>
                {open || !open ? (
                  <IconButton
                    aria-label="open drawer"
                    onClick={handleDrawerOpen}
                    edge="start"
                  >
                    <MenuIcon sx={{ color: themes.headLine }} />
                  </IconButton>
                ) : null}
              </Mui.Stack>
              <Box sx={{ flexGrow: 1 }} />
            </Mui.Grid>
            {currentLocation === "My Zone" ? (
              <Mui.Grid xs={3} sm={5.5} md={4} lg={2.2} xl={2.2}></Mui.Grid>
            ) : null}
            <Mui.Grid xs={4.5} sm={4.7} md={3.5} lg={2.3} xl={2.3}>
              <Search
                sx={{
                  backgroundColor: "white",
                  "&:focus-within": {
                    backgroundColor: themes.whiteColor,
                  },
                  "&:hover": {
                    backgroundColor: themes.formBackground,
                  },
                }}
              >
                <SearchIconWrapper>
                  <SearchIcon style={{ color: themes.headLine }} />
                </SearchIconWrapper>
                <StyledInputBase
                  sx={{
                    color: themes.headLine,
                    border: `3px solid ${themes.formBackground}`,
                    borderRadius: 3,
                  }}
                  placeholder="Search…"
                  value={globalSearchValue}
                  inputProps={{ "aria-label": "search" }}
                  onChange={(event) => {
                    dispatch(setGlobalSearchValue(event.target.value));
                  }}
                  fullWidth
                />
              </Search>
            </Mui.Grid>
            {currentLocation !== "My Zone" ? (
              <Mui.Grid xs={3} sm={5.5} md={4} lg={2.2} xl={2.2}>
                {companyList && companyList.length === 1 ? (
                  <Typography
                    variant="h6"
                    noWrap
                    component="div"
                    sx={{
                      marginTop: 0.5,
                      marginRight: 5,
                      display: { xs: "none", md: "flex" },
                      color: themes.headLine,
                    }}
                  >
                    {topbarCompanyName}
                  </Typography>
                ) : companyList ? (
                  <CustomAutoComplete
                    dataList={companyList
                      .filter((obj) =>
                        currentLocation === "Payroll"
                          ? obj.company_name !== "All"
                          : true,
                      )
                      .map((obj) => ({
                        ...obj,
                        label: obj.company_name,
                      }))}
                    selectedValue={topbarCompanyName}
                    updateDataFunction={changeCompany}
                    placeHolder="Select the company"
                  />
                ) : null}
              </Mui.Grid>
            ) : null}
            <Mui.Grid
              xs={1.5}
              sm={0.7}
              md={0.5}
              lg={0.4}
              xl={0.4}
              sx={{ ...rowEndStyle }}
            >
              <IconButton
                onClick={handleClick}
                size="small"
                sx={{ ml: 2 }}
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <Mui.Avatar
                  sx={{
                    width: 32,
                    height: 32,
                    bgcolor: "purple",
                  }}
                  alt={firstLetter}
                  src={userDetails?.image_url}
                />
              </IconButton>
            </Mui.Grid>
            <Mui.Grid xs={1} sm={0.1} md={0} lg={0.1} xl={0.1}></Mui.Grid>
          </Mui.Grid>
        </Mui.AppBar>
        <Mui.Divider />
        <Mui.Grid sx={{ paddingTop: 6 }}></Mui.Grid>
        <Box component="main">{currentRoute.component}</Box>
        <GlobalDialogBox
          handleCloseDialog={handleClose}
          open={openDialog1}
          title="Device Status"
          minWidth={700}
        >
          {deviceDetails && (
            <Grid xs={12}>
              <div>
                <DialogContent>
                  <Card
                    style={getCardBackgroundColor(deviceDetails.status_value)}
                  >
                    <CardContent>
                      <Typography>
                        <h3>Overall Status : {deviceDetails.overall_status}</h3>
                      </Typography>
                      <Typography>
                        <h3>
                          {" "}
                          Status Value :{" "}
                          {deviceDetails.status_value === "Green"
                            ? "Good"
                            : deviceDetails.status_value === "Red"
                              ? "Poor"
                              : "Moderate"}
                        </h3>
                      </Typography>
                    </CardContent>
                  </Card>
                </DialogContent>
                {deviceDetails.devices.length > 0 ? (
                  <Mui.Grid style={{ height: "110px" }}>
                    <Mui.Typography sx={{ fontWeight: 800, paddingLeft: 2 }}>
                      Devices:
                    </Mui.Typography>
                    <ul>
                      {deviceDetails.devices.map((device, index) => (
                        <li key={index}>
                          <Mui.Grid>
                            <Mui.Typography>
                              <b>Device Name : </b>
                              {device.device_name}
                            </Mui.Typography>
                            <Mui.Typography>
                              <b>Serial Number : </b>
                              {device.device_serial_number}
                            </Mui.Typography>{" "}
                            <Mui.Typography>
                              <b>Company Name : </b>
                              {device.company_name}
                            </Mui.Typography>{" "}
                            <Mui.Typography>
                              <b>Location : </b>
                              {device.device_location}
                            </Mui.Typography>
                            <Mui.Typography>
                              <b>Status : </b>
                              {device.device_status}
                            </Mui.Typography>
                          </Mui.Grid>
                        </li>
                      ))}
                    </ul>
                  </Mui.Grid>
                ) : (
                  <Alert sx={{ marginTop: 3 }} severity="info">
                    No devices found
                  </Alert>
                )}
              </div>
            </Grid>
          )}
        </GlobalDialogBox>
      </Box>
      <UserSidePeek
        openSidePeek={openSidePeek}
        setOpenSidePeek={setOpenSidePeek}
        firstLetter={firstLetter}
        userDetails={userDetails}
        setUpdateProfileSidePeek={setUpdateProfileSidePeek}
        updateProfileSidePeek={updateProfileSidePeek}
        fetchData={fetchData}
      />
    </>
  );
};
